import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, X } from "lucide-react";

export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div
      className="bg-brand-ink text-white text-sm relative z-40"
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-10 md:h-11 flex items-center justify-between gap-4">
        <Link
          to="/formations/initiation-ia"
          className="flex items-center gap-2 md:gap-3 truncate hover:text-brand-cta transition-colors"
          data-testid="announcement-link"
        >
          <Calendar className="w-3.5 h-3.5 text-brand-cta shrink-0" />
          <span className="font-bold text-[11px] md:text-xs tracking-[0.2em] uppercase text-brand-cta hidden sm:inline">
            Prochaine session
          </span>
          <span className="hidden sm:inline text-white/40">·</span>
          <span className="truncate font-medium text-xs md:text-sm">
            Initiation IA — 19-20 janvier 2027 · Places limitées
          </span>
          <span className="hidden md:inline-flex items-center gap-1 font-bold text-brand-cta ml-1">
            Réserver <ArrowUpRight className="w-3.5 h-3.5" />
          </span>
        </Link>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Fermer l'annonce"
          data-testid="announcement-close"
          className="text-white/60 hover:text-white transition-colors p-1 -mr-1 shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
